// src/stores/user.js
import { defineStore } from 'pinia'

export const useUserStore = defineStore('userStore', {
  state: () => ({
    token: null, // Access Token
    refreshToken: null,
    refresh: null,
    role: null,
    authenticated: false,
    juid: null,
    username: null,
    isPasswordChanged: null,
  }),
  actions: {
    setToken(token) {
      this.token = token
    },
    setRefresh(refresh) {
      this.refresh = refresh
    },
    setRole(role) {
      this.role = role
    },
    setUsername(username) {
      this.username = username
    },
    setIsPasswordChanged(isPasswordChanged) {
      this.isPasswordChanged = isPasswordChanged
    },
    setJuid(juid) {
      this.juid = juid
    },
    setAuthenticated(authenticated) {
      this.authenticated = authenticated
    },

    clearUser() {
      this.token = null
      this.refresh = null
      this.role = null
      ;(this.authenticated = false), (this.juid = null)
    },
    clearRefreshToken() {
      this.refreshToken = null
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'userStore',
        storage: localStorage,
      },
    ],
  },
})
